var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAUvDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9116 35.9869C11.0047 35.36 9.85597 35.645 8.5863 36.8037C6.83295 38.3804 6.77251 38.9882 8.34448 39.0262C9.75522 39.0642 12.7177 36.5378 11.9116 35.9869Z",
    fill: "url(#paint0_linear_1660_1577)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8033 32.7764C11.8033 32.2825 9.92904 31.7696 9.18336 32.0736C7.93385 32.5675 0.900334 37.7723 0.396498 37.9623C-0.832863 38.4182 1.06156 39.349 2.4723 38.988C3.76212 38.6461 11.8033 33.3083 11.8033 32.7764Z",
    fill: "url(#paint1_linear_1660_1577)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01081 13.3822C7.52231 13.4012 7.92534 12.9073 6.97813 12.1665C5.14417 10.7038 3.71331 10.2099 2.58472 10.6658C1.25459 11.1787 3.97531 13.3442 6.01081 13.3822Z",
    fill: "url(#paint2_linear_1660_1577)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5337 15.3965C30.622 15.4155 32.6575 14.2187 32.5366 13.6299C32.3149 12.5661 30.0577 12.5661 28.8485 13.6299C27.5385 14.7696 27.7602 15.3775 29.5337 15.3965Z",
    fill: "url(#paint3_linear_1660_1577)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4876 12.8318C12.4626 13.1738 12.3216 12.262 9.88303 8.99474C5.38881 2.97308 3.87728 1.45342 2.80915 1.87133C1.37826 2.40321 8.43198 12.452 10.4876 12.8318Z",
    fill: "url(#paint4_linear_1660_1577)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1365 9.96362C40.149 10.3625 32.793 14.9595 30.959 16.3082C30.556 16.6122 31.9466 17.144 32.9744 17.0681C34.0022 16.9921 34.3851 16.8021 38.5166 14.2377C40.9552 12.718 43.2123 11.3313 43.5146 11.1603C44.9657 10.3055 42.8697 9.26078 41.1365 9.96362Z",
    fill: "url(#paint5_linear_1660_1577)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1152 34.4482C32.0269 33.4984 30.5154 32.9665 30.0922 33.3844C29.8302 33.6314 30.3945 34.2392 31.4223 34.7901C33.0749 35.6829 34.2639 35.4359 33.1152 34.4482Z",
    fill: "url(#paint6_linear_1660_1577)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3034 24.1731C31.3917 23.6412 31.3715 23.4892 30.1422 22.3495C26.3735 18.8732 23.2295 10.857 22.5242 2.99278C22.2622 0.162406 19.4608 -2.516 17.9695 4.2275C16.0751 12.7376 11.6011 21.3997 8.63851 22.2925C6.64332 22.9003 6.86502 24.1731 8.96098 24.1731C12.0645 24.1731 13.959 26.8135 15.1682 32.8921C15.9541 36.8432 17.2843 42.9599 17.4052 43.2828C17.7075 44.0426 20.4685 45.2774 21.194 40.2245C22.2017 33.0821 26.1518 26.1676 30.3034 24.1731ZM26.8169 23.2993C23.4915 25.5218 20.2065 29.8338 19.3601 33.1201C19.1585 33.8799 18.9369 33.7659 18.7756 32.8351C17.9896 28.0862 16.3169 25.2368 13.4954 23.7362L12.4071 23.1473C15.3092 20.2409 16.6192 19.1962 19.9848 10.2872C20.1259 9.90729 20.1461 9.96428 20.8716 12.2628C22.2219 16.6317 23.9148 19.747 26.0913 21.8936C27.1796 22.9953 27.1998 23.0523 26.8169 23.2993Z",
    fill: "url(#paint7_linear_1660_1577)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4681 34.7895C25.8837 35.1124 26.0449 35.4163 27.758 37.4679C30.7608 41.0581 32.353 42.1218 33.3405 41.191C33.804 40.7541 33.5622 40.3552 31.3654 37.8098C28.6447 34.6565 27.7378 34.1056 26.4681 34.7895Z",
    fill: "url(#paint8_linear_1660_1577)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1660_1577",
    x1: 7.2158,
    y1: 37.344,
    x2: 12.0483,
    y2: 37.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1660_1577",
    x1: -0.0000378381,
    y1: 35.525,
    x2: 11.8033,
    y2: 35.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1660_1577",
    x1: 2.23241,
    y1: 11.942,
    x2: 7.48745,
    y2: 11.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1660_1577",
    x1: 28.0098,
    y1: 14.1141,
    x2: 32.5417,
    y2: 14.1141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1660_1577",
    x1: 2.61911,
    y1: 7.35162,
    x2: 11.8522,
    y2: 7.35162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1660_1577",
    x1: 30.8877,
    y1: 13.403,
    x2: 44.0007,
    y2: 13.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1660_1577",
    x1: 30.0283,
    y1: 34.2906,
    x2: 33.5715,
    y2: 34.2906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1660_1577",
    x1: 7.25871,
    y1: 21.9902,
    x2: 31.0932,
    y2: 21.9902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1660_1577",
    x1: 26.1621,
    y1: 38.019,
    x2: 33.5371,
    y2: 38.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAUvDiamond);
export default __webpack_public_path__ + "static/media/aUV_diamond.04bc79ef14f2a47856c509a19e7f00bb.svg";
export { ForwardRef as ReactComponent };